import ASTBlock from "../ASTBlock";
import Blockly from 'blockly';

export default class AlvikGetToFDistance extends ASTBlock {
    constructor(color) {
        super(color, "alvik_get_tof_distance")
        this.predefinedInputs = {}
        this.TOP_LEVEL = undefined
    }

    addToBlockly() {
        var json = {
            "type": "BooleanBlock",
            "tooltip": "",
            "helpUrl": "",
            "message0": "Abstand des %1 Abstandssensors %2",
            "args0": [{
                    "type": "field_dropdown",
                    "name": "tof",
                    "options": [
                        [
                            "linken",
                            "0"
                        ],
                        [
                            "mittleren linken",
                            "1"
                        ],
                        [
                            "mittleren",
                            "2"
                        ],
                        [
                            "mittleren rechten",
                            "3"
                        ],
                        [
                            "rechten",
                            "4"
                        ],
                        [
                            "oberen",
                            "5"
                        ],
                        [
                            "unteren",
                            "6"
                        ]
                    ]
                },
                {
                    "type": "input_dummy",
                    "name": "NAME"
                }
            ],
            "output": "Number"
        }

        let that = this
        Blockly.Blocks[this.name] = {
            init: function() {
                this.jsonInit(json);
                this.setColour(that.color)
            }

        }
    }
}